import { useStore } from "../../stores/StoreContext";
import { TranslationService } from "../LogicServices/TranslationService";

export function useTranslationService(): TranslationService {
  const storeContext = useStore();
  return new TranslationService(storeContext);
}
